import * as React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

export interface AddNewOrderViewProps {

}
// const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            height: '70vh'
        },
        pos: {
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            justifyItems: 'center'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        control: {
            padding: theme.spacing(2)
        },
    }),

);

export const AddNewOrderView: React.StatelessComponent<AddNewOrderViewProps> = (props) => {

    const classes = useStyles({});

    const [age, setAge] = React.useState('');
    const inputLabel = React.useRef<HTMLLabelElement>(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    React.useEffect(() => {
        setLabelWidth(inputLabel.current!.offsetWidth);
    });

    const handleChange = (event: React.ChangeEvent<{ value: string }>) => {
        setAge(event.target.value as string);
    };

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={8} md={6}>
                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                        <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">Select Service Order</InputLabel>
                        <Select
                            fullWidth
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={age}
                            onChange={handleChange}
                            labelWidth={labelWidth}
                        >
                            {/* <MenuItem value="">
                                <em>None</em>
                            </MenuItem> */}
                            <MenuItem value={1}>Smile Design - Simple</MenuItem>
                            <MenuItem value={2}>Smile Design - Advanced</MenuItem>
                        </Select>
                        <Button variant="contained" color="primary">
                                Next
                            </Button>
                    </FormControl>
                    <Grid item xs={3} sm={3} md={3}>
                        <div className={classes.pos} />
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default AddNewOrderView;



// WEBPACK FOOTER //
// ./src/components/layouts/AddNewOrderView.tsx